var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup491421(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49142",
    "data-name": "Group 49142",
    transform: "translate(-1384 -4081)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19517",
    "data-name": "Rectangle 19517",
    width: 32,
    height: 32,
    transform: "translate(1384 4081)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "d0b8c2d96c575e3d41c1003e01c3874d",
    d: "M13.746,11.264c-1.239-.113-1.915,1.577-2.817,2.028-1.465.789-4.169-2.028-4.169-2.028S3.944,8.559,4.62,7.095c.563-.9,2.253-1.577,2.141-2.817C6.648,3.151,4.169-.9,2.93.222.226,2.7,0,3.715,0,5.743-.112,9.235,4.394,13.63,4.394,13.63c.451.451,4.394,4.507,7.887,4.394,2.028,0,3.042-.225,5.521-2.929,1.127-1.239-2.817-3.718-4.056-3.831Z",
    transform: "translate(1391 4087.975)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup491421);
export default __webpack_public_path__ + "static/media/Group 49142-1.6ec3f176fb2cc17b8ec587055e3f2d7b.svg";
export { ForwardRef as ReactComponent };